<template>
  <v-container fluid>
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="12">
        <v-toolbar color="white" flat>
          <v-toolbar-title class="text-h5">用户列表</v-toolbar-title>
        </v-toolbar>
      </v-col>
      <v-col cols="12">
        <v-card outlined>
          <v-card-actions class="pb-0 px-4">
            <v-subheader class="px-0">用户列表</v-subheader>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="查找" single-line hide-details></v-text-field>
            <v-spacer></v-spacer>
            <v-btn outlined small color="primary" @click.stop="openInsertDialog()">新增</v-btn>
          </v-card-actions>
          <v-card-text>
            <v-data-table v-model="currentItems" show-select :loading="loading" :headers="headers" :items="infoList"
              :search="search" :items-per-page="10" :footer-props="{ itemsPerPageOptions: [10, 20, 40, 80] }">
              <template v-slot:[`item.extraInfo.isSelf`]="{ item }">
                <span>{{ !!Number(item.extraInfo.isSelf) ? '是' : '否' }}</span>
              </template>
              <template v-slot:[`item.extraInfo.customize`]="{ item }">
                <span>{{ !!Number(item.extraInfo.customize) ? '是' : '否' }}</span>
              </template>
              <template v-slot:[`item.updateTime`]="{ item }">
                <span>{{ item.updateTime ? formatDate(item.updateTime) : '暂无' }}</span>
              </template>
              <template v-slot:item.province="{ item }">
                {{ item.province }} {{ item.city }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-icon small class="mr-2" @click="openEditDialog(item)">mdi-pencil</v-icon>
                    </span>
                  </template>
                  <span>编辑</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-icon small class="mr-2" @click="openDeleteDialog(item)">mdi-delete</v-icon>
                    </span>
                  </template>
                  <span>删除</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-icon small class="mr-2" @click.stop="
                        detailsDialog = true;
                      detailsRow = item;
                      ">mdi-information-outline</v-icon>
                    </span>
                  </template>
                  <span>查看</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-icon small @click="editAppVersion(item)">mdi-link-variant</v-icon>
                    </span>
                  </template>
                  <span>选择App版本</span>
                </v-tooltip>
              </template>
              <template v-slot:footer>
                <v-btn color="error darken-1" text @click="deleteDialog = true"
                  :disabled="currentItems.length === 0">删除</v-btn>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary" @click="init">Reset</v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="editDialog" persistent max-width="600px">
      <ValidationObserver ref="form">
        <v-card>
          <v-card-title style="padding-left: 60px; padding-bottom: 0; padding-top: 40px">
            <span class="headline">信息配置</span>
          </v-card-title>
          <v-card-text style="padding-right: 50px; padding-left: 50px; padding-bottom: 10px ">
            <v-container style="padding-top: 0">
              <v-form>
                <v-row dense no-gutters>
                  <v-col cols="6" sm="6" md="6">
                    <ValidationProvider v-slot="{ errors }" name="名称" rules="required">
                      <v-text-field label="名称*" v-model="editedItem.uniName" required
                        :error-messages="errors"></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="2" sm="2" md="2"></v-col>
                  <v-col cols="4" sm="4" md="4">
                    <v-switch inset label="定制" v-model="editedItem.extraInfo.customize"></v-switch>
                  </v-col>
                  <v-col cols="5" sm="5" md="5">
                    <v-text-field label="ID*" disabled v-model="editedItem.id" required hint="唯一id"
                      :error-messages="errors"></v-text-field>
                  </v-col>
                  <v-col cols="2" sm="2" md="2"></v-col>
                  <v-col cols="5" sm="5" md="5">
                    <v-text-field v-model="editedItem.bundleId" label="绑定ID"></v-text-field>
                  </v-col>
                  <v-col cols="5" sm="5" md="5">
                    <v-file-input label="校企图标" v-model="uploadFile" accept="image/*" truncate-length="10">
                    </v-file-input>
                  </v-col>
                  <v-col cols="2" sm="2" md="2"> </v-col>
                  <v-col cols="5" sm="5" md="5">
                    <v-file-input label="应用图标" v-model="uploadAppIconFile" accept="image/*" truncate-length="10">
                    </v-file-input>
                  </v-col>
                  <v-col cols="2" sm="2" md="2"> </v-col>
                  <v-col cols="2" sm="2" md="2">
                    <v-card>
                      <v-img max-height="80" max-width="80" :src="iconUrl"></v-img>
                    </v-card>
                  </v-col>
                  <v-col cols="5" sm="5" md="5"> </v-col>
                  <v-col cols="2" sm="2" md="2">
                    <v-card>
                      <v-img max-height="80" max-width="80" :src="appIconUrl"></v-img>
                    </v-card>
                  </v-col>
                  <v-col cols="1" sm="1" md="1"> </v-col>
                  <v-col cols="5" sm="5" md="5">
                    <ValidationProvider v-slot="{ errors }" name="province" rules="required">
                      <v-select @click="getParentAreaInfoList" @change="getChildAreaInfoList()"
                        :items="parentAreaInfoList" v-model="province" return-object item-text="name" label="省(市)*"
                        :error-messages="errors"></v-select>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="2" sm="2" md="2"></v-col>
                  <v-col cols="5" sm="5" md="5">
                    <ValidationProvider v-slot="{ errors }" name="city" rules="required">
                      <v-select :items="childAreaInfoList" v-model="city" item-text="name" label="(市)区*"
                        :error-messages="errors" return-object></v-select>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-combobox v-model="terminalListSelect" :items="terminalList" chips clearable label="终端类型" multiple>
                      <template v-slot:selection="{ attrs, item, select, selected }">
                        <v-chip v-bind="attrs" :input-value="selected" close @click="select"
                          @click:close="removeTerminal(item)">
                          <strong>{{ item.label || item }}</strong>
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" v-for="(item, index) in terminalListEdit" :key="index">
                    <div class="terminal-item">
                      <span>{{ item.label }}</span>
                      <ValidationProvider v-slot="{ errors }" :name="item.code" :rules="item.require ? 'required' : ''">
                        <v-text-field :label="item.require ? '对应appId*' : '对应appId'" v-model="item.appId"
                          :required="item.require" :error-messages="item.require ? errors : ''" />
                      </ValidationProvider>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <ValidationProvider v-slot="{ errors }" name="用户类型" rules="required">
                      <v-select :items="[
                        { name: '学校', value: 'education' },
                        { name: '企业', value: 'enterprise' },
                        { name: '其他', value: 'other' }
                      ]" label="用户类型*" v-model="editedItem.extraInfo.customerType" item-text="name" item-value="value"
                        required :error-messages="errors"></v-select>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="7" sm="7" md="7"></v-col>
                  <v-col cols="12" sm="12" md="12">
                    <ValidationProvider v-slot="{ errors }" name="url" :rules="'required' + (isHttps ? '|isHttps' : '')">
                      <v-text-field label="接口地址*" v-model="editedItem.url" required :error-messages="errors" />
                    </ValidationProvider>
                  </v-col>
                  <!-- <v-col cols="12" sm="8" md="8">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="地址"
                      rules="required"
                    >
                      <v-text-field
                        prepend-inner-icon="mdi-map-marker"
                        label="接口地址*"
                        v-model="editedItem.url"
                        hint="配置地址"
                        required
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col> -->
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.websocket" label="websocket"></v-text-field>
                  </v-col>
                  <v-col cols="4" sm="4" md="4"> </v-col>
                  <v-col cols="12">
                    <v-textarea name="info" label="描述" v-model="editedItem.extraInfo.info" value="" hint="描述信息"
                      rows="1"></v-textarea>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <small>*号为必填项</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="normal darken-1 " text @click="closeEditDialog()">取消</v-btn>
            <v-btn color="primary darken-1 " text @click="editItem()">保存</v-btn>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>

    <!--    <v-card-actions>-->
    <!--      <v-spacer></v-spacer>-->
    <!--      <v-btn color="normal darken-1 " text @click="closeEditDialog()">取消</v-btn>-->
    <!--      <v-btn color="primary darken-1 " text @click="editItem()">保存</v-btn>-->
    <!--    </v-card-actions>-->
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">删除配置</span>
        </v-card-title>
        <v-card-text class="pb-0">
          是否确认要删除所选的{{
            this.currentItems.length > 0 ? this.currentItems.length : 1
          }}条配置？<br />
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="normal" @click="closeDeleteDialog" text>
            取消
          </v-btn>
          <v-btn color="error" @click="deleteItem" text>
            确定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="insertDialog" persistent max-width="600px">
      <!-- <pre>{{ editedItem }}</pre> -->
      <ValidationObserver ref="form">
        <v-card>
          <v-card-title style="padding-left: 60px; padding-bottom: 0; padding-top: 40px">
            <span class="headline">信息配置</span>
          </v-card-title>
          <v-card-text style="padding-right: 50px; padding-left: 50px; padding-bottom: 10px ">
            <v-container style="padding-top: 0">
              <v-form>
                <v-row dense no-gutters>
                  <v-col cols="6" sm="6" md="6">
                    <ValidationProvider v-slot="{ errors }" name="名称" rules="required">
                      <v-text-field label="名称*" v-model="editedItem.uniName" required
                        :error-messages="errors"></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="2" sm="2" md="2"></v-col>
                  <v-col cols="4" sm="4" md="4">
                    <v-switch inset label="定制" v-model="editedItem.extraInfo.customize"></v-switch>
                  </v-col>
                  <!-- <v-col cols="5" sm="5" md="5">
                    <ValidationProvider v-slot="{ errors }" name="ID" rules="required|numeric">
                      <v-text-field label="ID*" v-model="editedItem.id" required hint="唯一id"
                        :error-messages="errors"></v-text-field>
                    </ValidationProvider>
                  </v-col> -->
                  <!-- <v-col cols="2" sm="2" md="2"></v-col> -->
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.bundleId" label="绑定ID"></v-text-field>
                  </v-col>
                  <v-col cols="5" sm="5" md="5">
                    <v-file-input label="校企图标" v-model="uploadFile" accept="image/*" truncate-length="10">
                    </v-file-input>
                  </v-col>
                  <v-col cols="2" sm="2" md="2"> </v-col>
                  <v-col cols="5" sm="5" md="5">
                    <v-file-input label="应用图标" v-model="uploadAppIconFile" accept="image/*" truncate-length="10">
                    </v-file-input>
                  </v-col>
                  <v-col cols="2" sm="2" md="2"> </v-col>
                  <v-col cols="2" sm="2" md="2">
                    <v-card>
                      <v-img v-if="uploadFile != null" max-height="80" max-width="80" :src="iconUrl"></v-img>
                    </v-card>
                  </v-col>
                  <v-col cols="5" sm="5" md="5"> </v-col>
                  <v-col cols="2" sm="2" md="2">
                    <v-card>
                      <v-img v-if="uploadAppIconFile != null" max-height="80" max-width="80" :src="appIconUrl"></v-img>
                    </v-card>
                  </v-col>
                  <v-col cols="1" sm="1" md="1"> </v-col>
                  <v-col cols="5" sm="5" md="5">
                    <ValidationProvider v-slot="{ errors }" name="province" rules="required">
                      <v-select @click="getParentAreaInfoList" @change="getChildAreaInfoList()"
                        :items="parentAreaInfoList" v-model="province" return-object item-text="name" label="省(市)*"
                        :error-messages="errors"></v-select>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="2" sm="2" md="2"></v-col>
                  <v-col cols="5" sm="5" md="5">
                    <ValidationProvider v-slot="{ errors }" name="city" rules="required">
                      <v-select :items="childAreaInfoList" v-model="city" item-text="name" label="(市)区*"
                        :error-messages="errors" return-object></v-select>
                    </ValidationProvider>
                  </v-col>
                  <!-- <v-col cols="12" sm="5" md="5">
                    <v-select
                      :items=" [{ name: '微信小程序', value: 'weChatMiniProgram' }, { name: '微信小程序商户版', value: 'weChatMiniMercacc' }] "
                      label="终端类型" item-text="name" item-value="value" v-model=" currentPlat "
                      @change=" platTypeChanged "></v-select>
                  </v-col> -->

                  <!-- <v-col cols="12" sm="12" md="12">
                    <v-combobox v-model="terminalListSelect" :items="map(terminalList, 'label')" chips clearable
                      label="终端类型" multiple>
                      <template v-slot:selection="{ attrs, item, select, selected }">
                        <v-chip v-bind="attrs" :input-value="selected" close @click="select"
                          @click:close="removeTerminal(item)">
                          <strong>{{ item }}</strong>
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-col> -->
                  <v-col cols="12" sm="12" md="12">
                    <v-combobox v-model="terminalListSelect" :items="terminalList" chips clearable label="终端类型" multiple>
                      <template v-slot:selection="{ attrs, item, select, selected }">
                        <v-chip v-bind="attrs" :input-value="selected" close @click="select"
                          @click:close="removeTerminal(item)">
                          <strong>{{ item.label || item }}</strong>
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" v-for="(item, index) in terminalListEdit" :key="index">
                    <div class="terminal-item">
                      <span>{{ item.label }}</span>
                      <ValidationProvider v-slot="{ errors }" :name="item.code" :rules="item.require ? 'required' : ''">
                        <v-text-field :label="item.require ? '对应appId*' : '对应appId'" v-model="item.appId"
                          :required="item.require" :error-messages="item.require ? errors : ''" />
                      </ValidationProvider>
                    </div>
                  </v-col>
                  <!-- <v-col cols="2" sm="2" md="2"> </v-col> -->
                  <!-- <v-col cols="12" sm="5" md="5">
                    <v-text-field
                      v-model="currentPlatInfo[currentPlat]"
                      label="平台类型对应ID"
                    ></v-text-field>
                  </v-col> -->
                  <v-col cols="12" sm="12" md="12">
                    <ValidationProvider v-slot="{ errors }" name="用户类型" rules="required">
                      <v-select :items="userTypeList.list" label="用户类型*" v-model="editedItem.extraInfo.customerType"
                        item-text="name" item-value="name" required :error-messages="errors"></v-select>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="7" sm="7" md="7"></v-col>
                  <!-- <v-col cols="12" sm="8" md="8">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="地址"
                      rules="required"
                    >
                      <v-text-field
                        prepend-inner-icon="mdi-map-marker"
                        label="接口地址*"
                        v-model="editedItem.url"
                        hint="配置地址"
                        required
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col> -->
                  <v-col cols="12" sm="12" md="12">
                    <ValidationProvider v-slot="{ errors }" name="url" :rules="'required' + (isHttps ? '|isHttps' : '')">
                      <v-text-field label="接口地址*" v-model="editedItem.extraInfo.url" required :error-messages="errors" />
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.websocket" label="websocket"></v-text-field>
                  </v-col>
                  <v-col cols="4" sm="4" md="4"> </v-col>
                  <v-col cols="12">
                    <v-textarea name="info" label="描述" v-model="editedItem.extraInfo.info" value="" hint="描述信息"
                      rows="1"></v-textarea>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <small>*号为必填项</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="normal darken-1" text @click="closeInsertDialog">取消</v-btn>
            <v-btn color="primary darken-1" text @click="save">保存</v-btn>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
    <!-- 详情列表 -->
    <v-dialog v-model="detailsDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">申请信息详情</span>
        </v-card-title>
        <div class="v-review">
          <div>
            <span class="review-label">客户类型：</span><span>{{ detailsRow.extraInfo.customerType }}</span>
          </div>
          <div>
            <span class="review-label">所属区域：</span><span>{{ detailsRow.extraInfo.area }}</span>
          </div>
          <div>
            <span class="review-label">电话：</span><span>{{ detailsRow.extraInfo.mobile }}</span>
          </div>
          <div>
            <span class="review-label">邮箱：</span><span>{{ detailsRow.extraInfo.postbox }}</span>
          </div>
          <div>
            <span class="review-label">终端类型：</span><span><v-chip color="primary" style="color:#fff; margin-right: 5px"
                v-for="item in initPlatType(detailsRow.extraInfo.platInfoList)" :key="item">{{ item }}</v-chip></span>
          </div>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="normal" @click="detailsDialog = false" text>取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { buildAxios } from '@/plugins/axios'
import { handleResponse } from '@/plugins/errorHandler'
import { formatDate } from '@/plugins/utils.js'
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, numeric, regex } from 'vee-validate/dist/rules'
import config from '@/plugins/config'
import { type } from '../../../public/terminalType.js'
import { map, cloneDeep, isEmpty, omit, reverse } from 'lodash'

extend('numeric', {
  ...numeric,
  message: '该字段必须为纯数字！'
})

extend('required', {
  ...required,
  message: '该字段为必填项！'
})

extend('isHttps', {
  ...regex,
  message: '该地址必须为https协议地址.',
  validate: value => {
    const myPattern = /^https:\/\//i
    return myPattern.test(value)
  }
})

export default {
  name: 'UrlInfo',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data: () => ({
    //  new data
    terminalListSelect: [],
    terminalListEdit: [],
    isHttps: false,
    terminalList: (() => {
      const arr = []
      for (const v of type.terminalTypeList) {
        for (const _v of v.list) {
          if (_v.status === 0) _v.disabled = true
          _v.text = _v.label
          _v.value = _v.code
        }
        arr.push(...v.list)
      }
      console.log('arr', arr)
      return arr
    })(),
    areaList: {
      list: type.areaList,
      map: (() => {
        const obj = {}
        type.areaList.forEach(item => {
          obj[item.key] = item.name
        })
        return obj
      })()
    },
    userTypeList: {
      list: [
        { name: '学校', value: 'education' },
        { name: '企业', value: 'enterprise' },
        { name: '其他', value: 'other' }
      ],
      map: {
        education: '学校',
        enterprise: '企业',
        other: '其他'
      }
    },

    search: '',
    loading: true,
    deleteDialog: false,
    editDialog: false,
    insertDialog: false,
    currentPlat: 'weChatMiniProgram',
    headers: [
      { text: 'ID', value: 'id' },
      { text: '名称', value: 'uniName' },
      // { text: 'ID', value: 'id' },
      { text: '省市（市区)', value: 'province' },
      { text: '地址', value: 'url', sortable: false, width: 180 },
      // { text: '定制', value: 'extraInfo.customize' },
      { text: '直营', value: 'extraInfo.isSelf', width: 120 },
      { text: '定制', value: 'extraInfo.customize', width: 120 },
      // { text: '直营', value: 'extraInfo.isSelf' },
      // { text: '联系人', value: 'extraInfo.contacts', width: 120 },
      // { text: '客户类型', value: 'extraInfo.customerType', width: 120 },
      // { text: '应用图标', value: 'extraInfo.appIconUrl', width: 120 },
      // { text: '校徽', value: 'extraInfo.iconUrl', width: 120 },
      // { text: '学校名称', value: 'extraInfo.info', width: 120 },
      // { text: '是否直营', value: 'extraInfo.isSelf', width: 120 },
      // { text: '是否定制', value: 'extraInfo.customize', width: 120 },
      // { text: '所属区域', value: 'extraInfo.area', width: 120 },
      // { text: '电话', value: 'extraInfo.mobile', width: 120 },
      // { text: '邮箱', value: 'extraInfo.postbox', width: 120 },
      // { text: '地址', value: 'extraInfo.url', width: 120 },
      { text: '个性化单号', value: 'extraInfo.orderNumber', width: 120 },
      { text: '更新时间', value: 'updateTime', width: 120 },
      { text: '编辑', value: 'actions', sortable: false, width: 200 }
    ],
    editedItem: {
      uniName: '',
      province: '',
      city: '',
      url: '',
      websocket: '',
      bundleId: '',
      extraInfo: {
        info: '',
        customize: false,
        pinyin: '',
        customerType: '',
        iconUrl: '',
        platInfoList: null
      }
    },
    defaultItem: {
      uniName: '',
      province: '',
      city: '',
      url: '',
      websocket: '',
      bundleId: '',
      extraInfo: {
        info: '',
        customize: false,
        pinyin: '',
        customerType: '',
        iconUrl: '',
        platInfoList: null
      }
    },
    detailsRow: {
      uniName: '',
      province: '',
      city: '',
      url: '',
      websocket: '',
      bundleId: '',
      extraInfo: {
        info: '',
        customize: false,
        pinyin: '',
        customerType: '',
        iconUrl: '',
        platInfoList: null
      }
    },
    detailsDialog: false,
    infoList: [],
    currentItem: null,
    originEditItem: null,
    currentItems: [], // 多选列表
    errors: 'error',
    uploadFile: null, // 上传文件
    uploadAppIconFile: null, // 应用图标上传文件
    iconUrl: '', // 图标地址
    appIconUrl: '', // 应用图标地址
    parentAreaInfoList: [],
    childAreaInfoList: [],
    province: null,
    city: null,
    currentPlatInfo: {
      // 平台信息
      weChatMiniProgram: '',
      weChatMiniMercacc: ''
    }
  }),
  computed: {},
  watch: {
    uploadFile () {
      // 控制图标预览的显示
      if (this.uploadFile === null || this.uploadFile === undefined) {
        if (this.editedItem.extraInfo.iconUrl != null) {
          this.iconUrl =
            config.fileUrl + '/' + this.editedItem.extraInfo.iconUrl
        } else {
          this.iconUrl = ''
        }
      } else {
        this.iconUrl = URL.createObjectURL(this.uploadFile)
      }
    },
    uploadAppIconFile () {
      // 控制图标预览的显示
      if (
        this.uploadAppIconFile === null ||
        this.uploadAppIconFile === undefined
      ) {
        if (this.editedItem.extraInfo.appIconUrl != null) {
          this.appIconUrl =
            config.fileUrl + '/' + this.editedItem.extraInfo.appIconUrl
        } else {
          this.appIconUrl = ''
        }
      } else {
        this.appIconUrl = URL.createObjectURL(this.uploadAppIconFile)
      }
    },
    editDialog (val) {
      this.terminalListSelect = []
      this.terminalListEdit = []
      if (!val) {
        this.iconUrl = ''
        // this.editedItem = Object.assign({}, this.defaultItem)
        this.editedItem = cloneDeep(this.defaultItem)
        this.province = null
        this.city = null
      }
    },
    insertDialog (val) {
      this.terminalListSelect = []
      this.terminalListEdit = []
    },
    editedItem (val) {
      const obj = {}
      for (const v of this.terminalList) {
        obj[v.code] = {
          label: v.label,
          isHttp: v.isHttp,
          require: v.require
        }
      }
      const b = map(val.extraInfo.platInfoList, (r) => {
        return {
          code: r.code,
          appId: r.appId
        }
      })
      console.log(b)
      for (const v of b) {
        const arr = []
        arr.push(this.terminalList.find((r) => r.code === v.code))
        this.terminalListSelect.push(...arr)
        this.terminalListEdit.push({
          label: obj[v.code].label,
          code: v.code,
          appId: v.appId,
          isHttp: obj[v.code].isHttp,
          require: obj[v.code].require,
          url: ''
        })
      }
      this.isHttps = false
      for (const v of map(this.terminalListEdit, 'isHttps')) {
        v && (this.isHttps = true)
      }
      // console.log('this.terminalListSelect', this.terminalListSelect)
    },
    terminalListSelect (val) {
      const arr = []
      const obj = {}
      const appIdObj = {}
      for (const v of this.terminalList) {
        obj[v.label] = {
          code: v.code,
          isHttps: v.isHttps,
          require: v.isAppid ? v.isAppid.require : false
        }
      }
      if (!isEmpty(this.editedItem.extraInfo.platInfoList)) {
        for (const r of this.editedItem.extraInfo.platInfoList) {
          appIdObj[r.code] = r.appId
        }
      }
      let [a, _a] = [[], []]
      for (const v of val) {
        if (typeof v === 'string') {
          _a.push(v)
        }
        if (typeof v === 'object') {
          _a.push(v.label)
        }
      }
      a = _a
      console.log(a)
      for (const v of a) {
        arr.push({
          label: v,
          code: obj[v].code,
          appId: appIdObj[obj[v].code] || '',
          isHttps: obj[v].isHttps,
          require: obj[v].require
        })
      }
      console.log(arr)
      this.isHttps = false
      for (const v of map(arr, 'isHttps')) {
        v && (this.isHttps = true)
      }
      this.terminalListEdit = arr
    }
  },
  created () {
    this.init()
  },
  methods: {
    map,
    cloneDeep,
    formatDate,
    init () {
      const request = buildAxios()
      request
        .get('uni/infoList')
        .then(res => {
          this.infoList = reverse(res.data.data)
          this.getParentAreaInfoList()
          this.loading = false
        })
        .catch(reason => {
          this.loading = false
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    },
    openInsertDialog () {
      this.insertDialog = true
    },
    openEditDialog (item) {
      // 原始对象
      this.originEditItem = item
      // 修改对象
      this.editedItem = JSON.parse(JSON.stringify(item))

      if (this.editedItem.extraInfo.iconUrl != null) {
        this.iconUrl = config.fileUrl + '/' + this.editedItem.extraInfo.iconUrl
      }
      if (this.editedItem.extraInfo.appIconUrl != null) {
        this.appIconUrl =
          config.fileUrl + '/' + this.editedItem.extraInfo.appIconUrl
      }
      if (
        this.editedItem.extraInfo.platInfoList != null &&
        this.editedItem.extraInfo.platInfoList.size !== 0
      ) {
        for (const platInfo of this.editedItem.extraInfo.platInfoList) {
          const platCode = platInfo.code
          const appId = platInfo.appId
          if (platCode === 'weChatMiniProgram') {
            this.currentPlatInfo.weChatMiniProgram = appId
          } else if (platCode === 'weChatMiniMercacc') {
            this.currentPlatInfo.weChatMiniMercacc = appId
          }
        }
      } else {
        this.currentPlatInfo = {}
      }
      this.province = {
        name: this.editedItem.province
      }
      for (const area of this.parentAreaInfoList) {
        if (area.name === this.province.name) {
          this.province.code = area.code
        }
      }
      this.city = {
        name: this.editedItem.city,
        code: this.editedItem.cityCode
      }
      this.getChildAreaInfoList()
      if (this.currentItems.length === 0) {
        this.editDialog = true
      }
      // 判断点击项是否为当前选择项
      if (this.currentItems.length === 1) {
        if (this.currentItems[0].id === this.editedItem.id) {
          this.editDialog = true
        }
      }
    },
    openDeleteDialog (item) {
      this.currentItem = item
      this.deleteDialog = true
    },
    editItem () {
      this.$refs.form.validate().then(success => {
        if (!success) return
        const request = buildAxios()
        const formData = new FormData()
        this.editedItem.province = this.province.name
        this.editedItem.city = this.city.name
        this.editedItem.cityCode = this.city.code
        if (
          this.editedItem.bundleId === null ||
          this.editedItem.bundleId === ''
        ) {
          this.editedItem.bundleId = 'com.synjones.mobilegroup.ECampus'
        }
        // 处理平台id
        // this.editedItem.extraInfo.platInfoList = []
        // for (const [key, value] of Object.entries(this.currentPlatInfo)) {
        //   const info = {}
        //   info.code = key
        //   info.appId = value
        //   this.editedItem.extraInfo.platInfoList.push(info)
        // }
        this.editedItem.extraInfo.platInfoList = map(this.terminalListEdit, item => omit(item, 'label', 'isHttps', 'require')) || undefined
        console.log(this.editedItem)
        console.log(this.currentPlatInfo)
        formData.append('editedItem', JSON.stringify(this.editedItem))
        if (
          (this.iconUrl === null || this.iconUrl === undefined) &&
          (this.uploadFile === null || this.uploadFile === undefined)
        ) {
          this.$emit('alert', {
            msg: '图标不允许为空',
            type: 'error'
          })
          return ''
        }
        if (this.uploadFile !== null && this.uploadFile !== undefined) {
          formData.append('icon', this.uploadFile)
        }
        if (
          this.uploadAppIconFile !== null &&
          this.uploadAppIconFile !== undefined
        ) {
          formData.append('appIcon', this.uploadAppIconFile)
        }
        request
          .post('uni/update/uniInfo', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(res => {
            this.$emit('alert', {
              msg: '修改成功',
              type: 'success'
            })
            this.originEditItem.province = this.editedItem.province
            this.originEditItem.city = this.editedItem.city
            this.originEditItem.url = this.editedItem.url
            this.originEditItem.extraInfo = res.data.data.data.extraInfo
            this.originEditItem.uniName = res.data.data.data.uniName
            this.originEditItem.id = res.data.data.data.id
          })
          .catch(reason => {
            this.$emit('alert', {
              msg: handleResponse(reason.response),
              type: 'error'
            })
          })
          .finally(() => {
            this.editDialog = false
            this.uploadFile = null
            this.uploadAppIconFile = null
            this.iconUrl = ''
            this.appIconUrl = ''
            // this.editedItem = Object.assign({}, this.defaultItem)
            this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
          })
      })
    },
    deleteItem () {
      const request = buildAxios()
      // 判断删除对象是指定删除还是多项删除
      if (this.currentItems.length > 0) {
        request
          .post('uni/delete/uniInfos', this.currentItems)
          .then(() => {
            this.$emit('alert', {
              msg: '删除成功',
              type: 'success'
            })
            for (let i = 0; i < this.currentItems.length; i++) {
              this.removeItemFromTable(this.currentItems[i])
            }
          })
          .catch(reason => {
            this.$emit('alert', {
              msg: handleResponse(reason.response),
              type: 'error'
            })
          })
          .finally(() => {
            this.currentItem = null
            this.currentItems = []
            this.deleteDialog = false
          })
      } else if (this.currentItems.length === 0 && this.currentItem != null) {
        request
          .post('uni/delete/uniInfo', this.currentItem)
          .then(() => {
            this.$emit('alert', {
              msg: '删除成功',
              type: 'success'
            })
            this.removeItemFromTable(this.currentItem)
          })
          .catch(reason => {
            this.$emit('alert', {
              msg: handleResponse(reason.response),
              type: 'error'
            })
          })
          .finally(() => {
            this.currentItem = null
            this.currentItems = []
            this.deleteDialog = false
          })
      }
    },
    platTypeChanged (value) { },
    closeEditDialog () {
      this.editDialog = false
      this.currentPlatInfo = {}
      this.currentPlat = 'weChatMiniProgram'
      this.iconUrl = this.appIconUrl = ''
    },
    closeDeleteDialog () {
      this.deleteDialog = false
      this.currentItem = null
    },
    closeInsertDialog () {
      this.insertDialog = false
      this.province = null
      this.city = null
      this.$refs.form.reset()
      this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
      this.currentPlatInfo = {}
      this.currentPlat = 'weChatMiniProgram'
    },
    save () {
      this.$refs.form.validate().then(success => {
        if (!success) return
        const request = buildAxios()
        const formData = new FormData()
        this.editedItem.province = this.province.name
        this.editedItem.city = this.city.name
        this.editedItem.cityCode = this.city.code
        this.editedItem.url = this.editedItem.extraInfo.url
        // this.editedItem.cityCode = this.city.code
        if (
          this.editedItem.bundleId === null ||
          this.editedItem.bundleId === ''
        ) {
          this.editedItem.bundleId = 'com.synjones.mobilegroup.ECampus'
        }
        // 处理平台id
        this.editedItem.extraInfo.platInfoList = []
        for (const { code, appId } of this.terminalListSelect) {
          const info = {}
          info.code = code
          info.appId = appId
          this.editedItem.extraInfo.platInfoList.push(info)
        }
        console.log(this.editedItem)
        formData.append('editedItem', JSON.stringify(this.editedItem))
        if (this.uploadFile === null || this.uploadFile === undefined) {
          this.$emit('alert', {
            msg: '图标不允许为空',
            type: 'error'
          })
          return ''
        }
        formData.append('icon', this.uploadFile)
        if (
          this.uploadAppIconFile !== null &&
          this.uploadAppIconFile !== undefined
        ) {
          formData.append('appIcon', this.uploadAppIconFile)
        }
        request
          .post('uni/add/uniInfo', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(res => {
            this.$emit('alert', {
              msg: '添加成功',
              type: 'success'
            })
            this.editedItem.extraInfo.iconUrl = res.data.data.extraInfo.iconUrl
            this.infoList.push(this.editedItem)
          })
          .catch(reason => {
            this.$emit('alert', {
              msg: handleResponse(reason.response),
              type: 'error'
            })
          })
          .finally(() => {
            this.insertDialog = false
            this.uploadFile = null
            this.uploadAppIconFile = null
            this.iconUrl = ''
            this.appIconUrl = ''
            this.$refs.form.reset()
            // this.editedItem = Object.assign({}, this.defaultItem)
            this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
          })
      })
    },
    removeItemFromTable (item) {
      const index = this.infoList.indexOf(item)
      this.infoList.splice(index, 1)
    },
    editAppVersion (item) {
      this.$store.commit('addCustomerMap', item)
      this.$router.push({
        name: 'EditAppVersion',
        params: { cusId: '' + item.id }
      })
    },
    initPlatType (platTypes) {
      //
      const platTypeArr = []
      const platType = map(platTypes, 'code')
      for (const val of platType) { platTypeArr.push(this.terminalList.find(r => r.code === val).label) }
      return platTypeArr
    },
    getParentAreaInfoList () {
      if (this.parentAreaInfoList.length === 0) {
        const request = buildAxios()
        request
          .get('area/parent')
          .then(res => {
            this.parentAreaInfoList = res.data.data
          })
          .catch(reason => {
            this.$emit('alert', {
              msg: handleResponse(reason.response),
              type: 'error'
            })
          })
      }
    },
    getChildAreaInfoList () {
      const request = buildAxios()
      if (this.province.code === undefined || this.province.code === null) {
        return
      }
      request
        .get('area/child?parentCode=' + this.province.code)
        .then(res => {
          this.childAreaInfoList = res.data.data
        })
        .catch(reason => {
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    },
    removeTerminal (item) {
      this.terminalListSelect.splice(this.terminalListSelect.indexOf(item), 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.v-review {
  padding: 16px 24px 10px;
}

.terminal-item {
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    margin-right: 1rem;
  }
}
</style>
